import { useState } from "react";

// components
import { Box, Container, Tab, Tabs } from "@mui/material";
import { tabStyle } from "utils/styles";
import { ServiceComp, TabPanel } from "utils/unitComponent";

import { upperFirst } from "lodash";

// ----------------------------------------------------------------------

export default function Service() {
  const nav = [
    { label: "Intro", value: "intro" },
    { label: "F&B", value: "fb" },
    { label: "E-ticket", value: "ticket" },
    { label: "Locker", value: "locker" },
    // { label: 'etc.', value: 'etc' },
  ];
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <Container
      sx={{
        py: 20,
        flexGrow: 1,
        display: "flex",
      }}
    >
      <Tabs
        orientation="vertical"
        value={value}
        onChange={handleChange}
        sx={{ ...tabStyle }}
      >
        {nav.map((item, i) => (
          <Tab key={i} id={`${item.value}`} label={item.label} />
        ))}
      </Tabs>
      {nav.map((item, i) => (
        <TabPanel key={i} active={value === i} index={i}>
          {ServiceComp[upperFirst(item.value)]()}
        </TabPanel>
      ))}
    </Container>
  );
}
